import React from "react";
import { ToastContainer } from "react-toastify";
import useNotificationData from "../hooks/useNotificationData";

/**
 * Mounts the ToastContainer and triggers notification fetching/showing
 * via useNotificationData. Renders nothing visible beyond the toast host.
 */
export default function NotificationsHost() {
  // Hook side-effects: fetches + shows notifications as toasts
  useNotificationData();

  return (
    <ToastContainer
      newestOnTop={false}
      position="bottom-right"
    />
  );
}